<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="auth-shell">
      <div class="logo">{{ 'app.title' | t }}</div>
      <div class="card glass-card">
        <h1>{{ 'auth.register.title' | t }}</h1>
        <p class="subtitle">{{ 'auth.register.subtitle' | t }}</p>
        <form [formGroup]="form" (ngSubmit)="submit()">
          <ion-item lines="none" class="glass-item">
            <ion-input type="email" [label]="'auth.register.email' | t" labelPlacement="floating" formControlName="email"></ion-input>
          </ion-item>
          <ion-item lines="none" class="glass-item">
            <ion-input type="password" [label]="'auth.register.password' | t" labelPlacement="floating" formControlName="password"></ion-input>
          </ion-item>
          <div class="error" *ngIf="error">{{ error }}</div>
          <div class="consent-note">
            By creating an account, you confirm you are at least 16 and accept our
            <a routerLink="/terms">Terms of Service</a> and
            <a routerLink="/privacy">Privacy Policy</a>.
          </div>
          <ion-button expand="block" class="futuristic-button" [disabled]="loading" type="submit">
            {{ 'auth.register.submit' | t }}
          </ion-button>
        </form>
        <div class="switch">
          {{ 'auth.register.switch' | t }} <a routerLink="/auth/login">{{ 'auth.register.switch.link' | t }}</a>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
